module.exports = __webpack_public_path__ + "img/ai.56237d0c.png";